import { useState } from 'react'

// #390: the conference-supplied promo banner for a talk.
//
// Almost no event has one, so the null path is the common path — this returns
// nothing and reserves no space, leaving the page exactly as it was before the
// feature existed.
//
// The bytes come from svc's public endpoint (#389), so this is a plain
// <img src>. It deliberately does NOT reuse `fetchEventImageObjectUrl` from
// lib/api.js: that exists because the AMA back office's byte endpoint is
// admin-only and needs an authed blob fetch. This one is anonymous.
//
// No aspect-ratio box. These banners are landscape social cards but the API
// does not report their dimensions, so any ratio here would be a guess — and a
// wrong guess letterboxes or crops the image, which is worse than the small
// reflow as it loads. Reserving space properly needs width/height stored at
// upload time; tracked separately.
export default function EventIllustration({ event }) {
  const [failed, setFailed] = useState(false)

  if (!event?.illustrationUrl || failed) return null

  return (
    <figure className="mt-6 overflow-hidden rounded-2xl shadow-sm ring-1 ring-slate-200/60">
      <img
        src={event.illustrationUrl}
        // The talk title, not a description of the artwork. These banners
        // render the title, the speaker and the slot as text inside the image,
        // so the title IS the image's information content — and svc does not
        // serve the stored altText on the public payload anyway.
        alt={event.title || 'Talk illustration'}
        loading="lazy"
        decoding="async"
        className="block h-auto w-full"
        // A banner that 404s or times out leaves the page as if there were no
        // illustration at all — never a broken-image icon, never an alert. The
        // image is decoration; it is not worth an error state.
        onError={() => setFailed(true)}
      />
    </figure>
  )
}
